import React from "react";
import DrsListManagement from "./_components/DrsListManagement";
import { usePermission } from "../../hooks/usePermissionTabs";

const DRSManagement: React.FC = () => {
  const { allowed: canReadDrs, isLoading: isLoadingDrs } = usePermission("drs", "read");
  const { allowed: canReadCod, isLoading: isLoadingCod } = usePermission("cod_orders", "read");

  const isLoading = isLoadingDrs || isLoadingCod;
  const canAccess = canReadDrs || canReadCod;

  if (isLoading) {
    return (
      <div className="px-4 md:px-6 space-y-4">
        <div className="bg-white rounded-xl p-6 h-64 animate-pulse" />
      </div>
    );
  }

  if (!canAccess) {
    return (
      <div className="px-4 md:px-6 space-y-4">
        <div className="bg-white rounded-xl p-6 text-center text-gray-500">
          No access to any section.
        </div>
      </div>
    );
  }

  return (
    <div className="px-4 md:px-6 space-y-4">
      <DrsListManagement />
    </div>
  );
};

export default DRSManagement;